import { render } from "./FullContent.vue?vue&type=template&id=3f53efb6&scoped=true"
import script from "./FullContent.vue?vue&type=script&lang=js"
export * from "./FullContent.vue?vue&type=script&lang=js"

import "./FullContent.vue?vue&type=style&index=0&id=3f53efb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f53efb6"]])

export default __exports__